var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("content-container", { attrs: { contentClass: "success" } }, [
    _c("h1", [_vm._v("Success!")]),
    _vm._v(" "),
    _c("p", [_vm._v("Please wait in line for your name(s) to be called")])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }